(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.storageKey = this.dataset.storageKey;
      if (this.isDismissed()) return;
      this.hidden = false;
      const closeBtn = this.querySelector('[data-announcement-close]');
      if (closeBtn) closeBtn.addEventListener('click', () => this.dismiss());
    }

    isDismissed() {
      try { return localStorage.getItem(this.storageKey) === '1'; }
      catch (e) { return false; }
    }

    dismiss() {
      try { localStorage.setItem(this.storageKey, '1'); } catch (e) {}
      this.hidden = true;
      this.dispatchEvent(new CustomEvent('announcement:dismissed', { bubbles: true }));
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands-index"] && !Shopify.designMode) return;
  try {
    
  class BrandsFilter extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('[data-filter]');
      this.grid = this.parentElement.querySelector('.brands-index__grid');
      if (!this.grid) return;
      this.items = this.grid.querySelectorAll('.brands-index__item');
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.apply(tab)));

      const params = new URLSearchParams(window.location.search);
      const initial = params.get('category');
      if (initial) {
        const match = Array.from(this.tabs).find((t) => t.dataset.filter === initial);
        if (match) this.apply(match);
      }
    }
    apply(tab) {
      const filter = tab.dataset.filter;
      this.tabs.forEach((t) => {
        const active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.items.forEach((item) => {
        const match = filter === 'all' || item.dataset.category === filter;
        item.classList.toggle('is-hidden', !match);
      });
    }
  }
  if (!customElements.get('brands-filter')) customElements.define('brands-filter', BrandsFilter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calc-bolt-pattern"] && !Shopify.designMode) return;
  try {
    
  class CalcBolt extends HTMLElement {
    connectedCallback() {
      this.lugs = this.querySelector('[data-input="lugs"]');
      this.unit = this.querySelector('[data-input="unit"]');
      this.value = this.querySelector('[data-input="value"]');
      [this.lugs, this.unit, this.value].forEach((el) => el.addEventListener('input', () => this.compute()));
      this.querySelectorAll('[data-preset]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const [lugs, mm] = btn.dataset.preset.split(',');
          this.lugs.value = lugs;
          this.unit.value = 'mm';
          this.value.value = mm;
          this.compute();
        });
      });
      this.compute();
    }
    compute() {
      const lugs = this.lugs.value;
      const v = parseFloat(this.value.value) || 0;
      const mm = this.unit.value === 'mm' ? v : v * 25.4;
      const inches = mm / 25.4;
      this.querySelector('[data-output="metric"]').textContent = `${lugs} × ${mm.toFixed(1)} mm`;
      this.querySelector('[data-output="imperial"]').textContent = `${lugs} × ${inches.toFixed(2)}"`;
    }
  }
  if (!customElements.get('calc-bolt')) customElements.define('calc-bolt', CalcBolt);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calc-metric-imperial"] && !Shopify.designMode) return;
  try {
    
  class CalcMetric extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('input').forEach((el) => el.addEventListener('input', () => this.compute()));
      this.compute();
    }
    compute() {
      const w = parseFloat(this.querySelector('[data-input="width"]').value) || 0;
      const a = parseFloat(this.querySelector('[data-input="aspect"]').value) || 0;
      const r = parseFloat(this.querySelector('[data-input="rim"]').value) || 0;
      const diameter = ((w * a) / 1270) + r;
      const section = w / 25.4;
      this.querySelector('[data-output="diameter"]').textContent = `${diameter.toFixed(1)}"`;
      this.querySelector('[data-output="section"]').textContent = `${section.toFixed(1)}"`;
      this.querySelector('[data-output="size"]').textContent = `${diameter.toFixed(1)}×${section.toFixed(1)}R${r}`;
    }
  }
  if (!customElements.get('calc-metric')) customElements.define('calc-metric', CalcMetric);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calc-offset-backspacing"] && !Shopify.designMode) return;
  try {
    
  class CalcOffset extends HTMLElement {
    connectedCallback() {
      this.width = this.querySelector('[data-input="width"]');
      this.offset = this.querySelector('[data-input="offset"]');
      this.out = this.querySelector('[data-output="backspacing"]');
      [this.width, this.offset].forEach((el) => el.addEventListener('input', () => this.compute()));
      this.compute();
    }
    compute() {
      const w = parseFloat(this.width.value) || 0;
      const o = parseFloat(this.offset.value) || 0;
      const bs = (w / 2) + (o / 25.4) + 0.5;
      this.out.textContent = `${bs.toFixed(2)}"`;
    }
  }
  if (!customElements.get('calc-offset')) customElements.define('calc-offset', CalcOffset);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calc-tire-size-comparison"] && !Shopify.designMode) return;
  try {
    
  class CalcTireSize extends HTMLElement {
    connectedCallback() {
      this.inputs = this.querySelectorAll('input');
      this.inputs.forEach((el) => el.addEventListener('input', () => this.compute()));
      this.compute();
    }
    dims(prefix) {
      const w = parseFloat(this.querySelector(`[data-input="${prefix}-width"]`).value) || 0;
      const a = parseFloat(this.querySelector(`[data-input="${prefix}-aspect"]`).value) || 0;
      const r = parseFloat(this.querySelector(`[data-input="${prefix}-rim"]`).value) || 0;
      const sidewall_mm = (w * a) / 100;
      const sidewall_in = sidewall_mm / 25.4;
      const diameter = r + (2 * sidewall_in);
      const circ = diameter * Math.PI;
      const revs = 63360 / circ;
      return { sidewall_in, diameter, circ, revs };
    }
    fmt(n, digits = 2) { return n.toFixed(digits); }
    delta(oldV, newV, unit = '', pctBasis = null) {
      const diff = newV - oldV;
      const pct = pctBasis ? (diff / pctBasis) * 100 : (diff / oldV) * 100;
      const sign = diff >= 0 ? '+' : '';
      return {
        text: `${sign}${diff.toFixed(2)}${unit} (${sign}${pct.toFixed(1)}%)`,
        cls: diff >= 0 ? 'is-up' : 'is-down',
      };
    }
    set(key, value, deltaInfo) {
      this.querySelector(`[data-output="${key}"]`).textContent = value;
      if (deltaInfo) {
        const el = this.querySelector(`[data-output="${key}-delta"]`);
        if (el) { el.textContent = deltaInfo.text; el.className = `calc__result-delta ${deltaInfo.cls}`; }
      }
    }
    compute() {
      const a = this.dims('a');
      const b = this.dims('b');
      this.set('diameter', `${this.fmt(b.diameter)}"`, this.delta(a.diameter, b.diameter, '"'));
      this.set('sidewall', `${this.fmt(b.sidewall_in)}"`, this.delta(a.sidewall_in, b.sidewall_in, '"'));
      this.set('circ', `${this.fmt(b.circ)}"`, this.delta(a.circ, b.circ, '"'));
      this.set('revs', `${this.fmt(b.revs, 0)}`, this.delta(a.revs, b.revs, ''));
      const speedoError = ((b.diameter - a.diameter) / a.diameter) * 100;
      this.set('speedo', `${speedoError >= 0 ? '+' : ''}${speedoError.toFixed(1)}%`);
    }
  }
  if (!customElements.get('calc-tire-size')) customElements.define('calc-tire-size', CalcTireSize);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calc-wheel-tire-clearance"] && !Shopify.designMode) return;
  try {
    
  class CalcClearance extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('input').forEach((el) => el.addEventListener('input', () => this.compute()));
      this.compute();
    }
    setup(p) {
      const ww = parseFloat(this.querySelector(`[data-input="${p}-wwidth"]`).value) || 0;
      const off = parseFloat(this.querySelector(`[data-input="${p}-offset"]`).value) || 0;
      const tw = parseFloat(this.querySelector(`[data-input="${p}-twidth"]`).value) || 0;
      const td = parseFloat(this.querySelector(`[data-input="${p}-tdia"]`).value) || 0;
      const backspacing = (ww / 2) + (off / 25.4) + 0.5;
      const frontspacing = ww - backspacing + 1;
      const tire_in = tw / 25.4;
      const inner = backspacing + ((tire_in - ww) / 2);
      const outer = frontspacing + ((tire_in - ww) / 2);
      return { backspacing, frontspacing, tire_in, inner, outer, td };
    }
    fmt(n, d = 2) { return `${n >= 0 ? '+' : ''}${n.toFixed(d)}"`; }
    compute() {
      const a = this.setup('a');
      const b = this.setup('b');
      this.querySelector('[data-output="inner"]').textContent = this.fmt(b.inner - a.inner);
      this.querySelector('[data-output="outer"]').textContent = this.fmt(b.outer - a.outer);
      this.querySelector('[data-output="twidth"]').textContent = this.fmt(b.tire_in - a.tire_in);
      const lift = Math.max(0, (b.td - a.td) / 2);
      this.querySelector('[data-output="lift"]').textContent = `${lift.toFixed(2)}"`;
    }
  }
  if (!customElements.get('calc-clearance')) customElements.define('calc-clearance', CalcClearance);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cart-page__qty').forEach((wrap) => {
    const input = wrap.querySelector('.cart-page__qty-input');
    if (!input) return;
    wrap.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      const v = parseInt(input.value, 10) || 1;
      if (v > 0) { input.value = v - 1; input.dispatchEvent(new Event('change')); }
    });
    wrap.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      const v = parseInt(input.value, 10) || 0;
      input.value = v + 1;
      input.dispatchEvent(new Event('change'));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  class FeaturedProducts extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-scroll-track]');
      this.prev = this.querySelector('[data-scroll-prev]');
      this.next = this.querySelector('[data-scroll-next]');
      if (!this.track || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this.scrollBy(-1));
      this.next.addEventListener('click', () => this.scrollBy(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows(), { passive: true });
      this.updateArrows();
    }

    scrollBy(direction) {
      const item = this.track.querySelector('.featured-products__item');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 16;
      const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    updateArrows() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const atStart = scrollLeft <= 2;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 2;
      this.prev.toggleAttribute('disabled', atStart);
      this.next.toggleAttribute('disabled', atEnd);
    }
  }

  if (!customElements.get('featured-products')) {
    customElements.define('featured-products', FeaturedProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guides-page"] && !Shopify.designMode) return;
  try {
    
  class GuidesFilter extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('[data-filter]');
      this.items = this.querySelectorAll('[data-tags]');
      this.empty = this.querySelector('.guides__empty');
      this.tabs.forEach(tab => tab.addEventListener('click', () => this.filter(tab)));
    }
    filter(tab) {
      const cat = tab.dataset.filter;
      this.tabs.forEach(t => t.classList.toggle('is-active', t === tab));
      let visible = 0;
      this.items.forEach(item => {
        const tags = item.dataset.tags || '';
        const show = cat === 'all' || tags.includes(cat);
        item.hidden = !show;
        if (show) visible++;
      });
      if (this.empty) this.empty.hidden = visible > 0;
    }
  }
  if (!customElements.get('guides-filter')) customElements.define('guides-filter', GuidesFilter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('[data-drawer]');
      this.setupSticky();
      this.setupDropdowns();
      this.setupDrawer();
      this.listenCartUpdates();
    }

    setupSticky() {
      if (this.dataset.sticky !== 'true') return;
      const onScroll = () => {
        this.classList.toggle('is-scrolled', window.scrollY > 8);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    setupDropdowns() {
      const items = this.querySelectorAll('[data-dropdown]');
      items.forEach((item) => {
        const trigger = item.querySelector('.header__nav-link');
        if (!trigger) return;
        item.addEventListener('mouseenter', () => this.openDropdown(item));
        item.addEventListener('mouseleave', () => this.closeDropdown(item));
        item.addEventListener('focusin', () => this.openDropdown(item));
        item.addEventListener('focusout', (e) => {
          if (!item.contains(e.relatedTarget)) this.closeDropdown(item);
        });
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          items.forEach((item) => this.closeDropdown(item));
        }
      });
    }

    openDropdown(item) {
      item.classList.add('is-open');
      const trigger = item.querySelector('[aria-haspopup]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    closeDropdown(item) {
      item.classList.remove('is-open');
      const trigger = item.querySelector('[aria-haspopup]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    setupDrawer() {
      if (!this.drawer) return;
      const opener = this.querySelector('[data-drawer-open]');
      const closers = this.querySelectorAll('[data-drawer-close]');
      if (opener) opener.addEventListener('click', () => this.openDrawer());
      closers.forEach((el) => el.addEventListener('click', () => this.closeDrawer()));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) this.closeDrawer();
      });
    }

    openDrawer() {
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      const opener = this.querySelector('[data-drawer-open]');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      const firstLink = this.drawer.querySelector('a, button');
      if (firstLink) firstLink.focus({ preventScroll: true });
    }

    closeDrawer() {
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
      const opener = this.querySelector('[data-drawer-open]');
      if (opener) {
        opener.setAttribute('aria-expanded', 'false');
        opener.focus({ preventScroll: true });
      }
    }

    listenCartUpdates() {
      const updateBubble = (count) => {
        const bubble = this.querySelector('[data-cart-count]');
        if (!bubble) return;
        bubble.textContent = count;
        bubble.classList.toggle('is-empty', count === 0);
      };

      document.addEventListener('cart:updated', (e) => {
        const count = e.detail && typeof e.detail.item_count === 'number' ? e.detail.item_count : null;
        if (count !== null) updateBubble(count);
      });

      const origFetch = window.fetch;
      window.fetch = (...args) => {
        const req = args[0];
        const url = typeof req === 'string' ? req : (req && req.url ? req.url : '');
        const isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
        const result = origFetch.apply(window, args);
        if (isCartMutation) {
          result.then((res) => res.clone().json()).then((data) => {
            const count = typeof data.item_count === 'number' ? data.item_count : null;
            if (count !== null) {
              updateBubble(count);
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: count } }));
            } else {
              origFetch('/cart.js').then((r) => r.json()).then((c) => {
                updateBubble(c.item_count);
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: c.item_count } }));
              });
            }
          }).catch(() => {});
        }
        return result;
      };
    }
  }

  if (!customElements.get('site-header')) {
    customElements.define('site-header', SiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  class CollectionTemplate extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.collectionUrl = this.dataset.collectionUrl;
      this.form = this.querySelector('[data-filter-form]');
      this.sortSelect = this.querySelector('[data-sort]');
      this.drawer = this.querySelector('[data-filter-drawer]');
      this.fetchAbort = null;

      this.setupDrawer();
      this.setupFilterChanges();
      this.setupSort();
      this.setupChipLinks();
      this.setupClearLinks();
      this.setupHistory();
    }

    setupDrawer() {
      if (!this.drawer) return;
      this.querySelectorAll('[data-filter-open]').forEach((el) => {
        el.addEventListener('click', () => this.openDrawer());
      });
      this.querySelectorAll('[data-filter-close], [data-filter-close-apply]').forEach((el) => {
        el.addEventListener('click', () => this.closeDrawer());
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) this.closeDrawer();
      });
    }

    openDrawer() {
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('filters-open');
    }

    closeDrawer() {
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('filters-open');
    }

    setupFilterChanges() {
      if (!this.form) return;
      let debounce;
      this.form.addEventListener('input', (e) => {
        if (e.target.matches('input[type="number"]')) {
          clearTimeout(debounce);
          debounce = setTimeout(() => this.applyFilters(), 500);
        } else {
          this.applyFilters();
        }
      });
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.applyFilters();
      });
    }

    setupSort() {
      if (!this.sortSelect) return;
      this.sortSelect.addEventListener('change', () => this.applyFilters());
    }

    setupChipLinks() {
      this.querySelectorAll('[data-filter-remove]').forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          this.fetchAndRender(link.href);
        });
      });
    }

    setupClearLinks() {
      this.querySelectorAll('[data-filter-clear]').forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          this.fetchAndRender(link.href);
        });
      });
    }

    setupHistory() {
      window.addEventListener('popstate', () => {
        this.fetchAndRender(window.location.href, { push: false });
      });
    }

    buildUrl() {
      const params = new URLSearchParams();
      if (this.sortSelect && this.sortSelect.value) {
        params.set('sort_by', this.sortSelect.value);
      }
      if (this.form) {
        new FormData(this.form).forEach((value, key) => {
          if (key === 'sort_by') return;
          if (value === '' || value == null) return;
          params.append(key, value);
        });
      }
      const query = params.toString();
      return query ? `${this.collectionUrl}?${query}` : this.collectionUrl;
    }

    applyFilters() {
      const url = this.buildUrl();
      this.fetchAndRender(url);
    }

    async fetchAndRender(url, { push = true } = {}) {
      if (this.fetchAbort) this.fetchAbort.abort();
      this.fetchAbort = new AbortController();
      this.classList.add('is-loading');

      try {
        const fetchUrl = new URL(url, window.location.origin);
        fetchUrl.searchParams.set('section_id', this.sectionId);
        const res = await fetch(fetchUrl.toString(), { signal: this.fetchAbort.signal });
        if (!res.ok) throw new Error(res.statusText);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('collection-template');
        if (!fresh) return;

        const replaceBy = (selector) => {
          const oldEl = this.querySelector(selector);
          const newEl = fresh.querySelector(selector);
          if (oldEl && newEl) oldEl.replaceWith(newEl);
        };

        replaceBy('[data-product-grid]');
        replaceBy('[data-active-filters]');
        replaceBy('[data-product-count]');
        replaceBy('.pagination');
        replaceBy('.collection-template__empty');

        // Refresh filter form contents (preserve drawer state + focus)
        const activeEl = document.activeElement;
        const activeName = activeEl && activeEl.name;
        const activeType = activeEl && activeEl.type;
        const oldForm = this.querySelector('[data-filter-form]');
        const newForm = fresh.querySelector('[data-filter-form]');
        if (oldForm && newForm) oldForm.innerHTML = newForm.innerHTML;
        if (activeName) {
          const restored = this.querySelector(`[data-filter-form] [name="${activeName}"]${activeType === 'number' ? '' : ''}`);
          if (restored) restored.focus();
        }

        if (push) history.pushState({}, '', url);
        this.setupChipLinks();
        this.setupClearLinks();
      } catch (err) {
        if (err.name !== 'AbortError') console.error(err);
      } finally {
        this.classList.remove('is-loading');
      }
    }
  }

  if (!customElements.get('collection-template')) {
    customElements.define('collection-template', CollectionTemplate);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductTemplate extends HTMLElement {
    connectedCallback() {
      this.variants = this.parseVariants();
      this.form = this.querySelector('[data-product-form]');
      this.variantIdInput = this.querySelector('[data-variant-id]');
      this.priceNode = this.querySelector('[data-price]');
      this.statusNode = this.querySelector('[data-status]');
      this.addBtn = this.querySelector('[data-add-to-cart]');
      this.addLabel = this.querySelector('[data-add-label]');

      this.setupGallery();
      this.setupVariantButtons();
      this.setupQuantity();
      this.setupAddToCart();
    }

    parseVariants() {
      const node = this.querySelector('[data-product-variants]');
      if (!node) return [];
      try { return JSON.parse(node.textContent); }
      catch { return []; }
    }

    /* Gallery */
    setupGallery() {
      const main = this.querySelector('[data-gallery-main]');
      if (!main) return;
      this.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const id = thumb.dataset.mediaId;
          this.showMedia(id);
        });
      });
    }

    showMedia(id) {
      this.querySelectorAll('[data-gallery-slide]').forEach((slide) => {
        const active = slide.dataset.mediaId === id;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.tabIndex = active ? 0 : -1;
      });
      this.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.mediaId === id);
      });
    }

    /* Variants */
    setupVariantButtons() {
      const buttons = this.querySelectorAll('[data-variant-button]');
      if (!buttons.length) return;
      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const index = Number(btn.dataset.optionIndex);
          const value = btn.dataset.optionValue;
          this.selectOption(index, value);
        });
      });
    }

    selectOption(index, value) {
      const group = this.querySelector(`[data-variant-option="${index}"]`);
      if (!group) return;
      group.querySelectorAll('[data-variant-button]').forEach((btn) => {
        btn.classList.toggle('is-selected', btn.dataset.optionValue === value);
      });
      const valueLabel = this.querySelector(`[data-variant-value="${index}"]`);
      if (valueLabel) valueLabel.textContent = value;
      this.updateMatchedVariant();
    }

    currentSelection() {
      const selections = [];
      this.querySelectorAll('[data-variant-option]').forEach((group) => {
        const selected = group.querySelector('.is-selected');
        selections.push(selected ? selected.dataset.optionValue : null);
      });
      return selections;
    }

    updateMatchedVariant() {
      const selection = this.currentSelection();
      const match = this.variants.find((v) =>
        v.options.every((opt, i) => opt === selection[i])
      );
      if (!match) return;

      this.variantIdInput.value = match.id;
      this.renderPrice(match);
      this.renderStatus(match);
      if (match.featured_media) this.showMedia(String(match.featured_media.id));

      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      history.replaceState({}, '', url);
    }

    formatMoney(cents) {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD',
      });
    }

    renderPrice(variant) {
      if (!this.priceNode) return;
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (onSale) {
        this.priceNode.innerHTML = `
          <span class="product-details__price-sale">${this.formatMoney(variant.price)}</span>
          <span class="product-details__price-compare">${this.formatMoney(variant.compare_at_price)}</span>
          <span class="badge badge--accent">Sale</span>
        `;
      } else {
        this.priceNode.innerHTML = `
          <span class="product-details__price-regular">${this.formatMoney(variant.price)}</span>
        `;
      }
    }

    renderStatus(variant) {
      if (!this.addBtn || !this.addLabel) return;
      const available = variant.available;
      this.addBtn.disabled = !available;
      this.addLabel.textContent = available ? 'Add to cart' : 'Sold out';
    }

    /* Quantity */
    setupQuantity() {
      const input = this.querySelector('[data-quantity-input]');
      const dec = this.querySelector('[data-quantity-decrease]');
      const inc = this.querySelector('[data-quantity-increase]');
      if (!input) return;
      dec && dec.addEventListener('click', () => {
        const v = Math.max(1, parseInt(input.value, 10) - 1);
        input.value = v;
      });
      inc && inc.addEventListener('click', () => {
        const v = Math.max(1, parseInt(input.value, 10) + 1);
        input.value = v;
      });
    }

    /* Add to cart */
    setupAddToCart() {
      if (!this.form) return;
      this.form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (this.addBtn.disabled) return;
        const original = this.addLabel.textContent;
        this.addBtn.disabled = true;
        this.addLabel.textContent = 'Adding…';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: new FormData(this.form),
          });
          if (!res.ok) throw new Error('Add to cart failed');
          const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          const cart = await cartRes.json();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          this.addLabel.textContent = 'Added ✓';
          setTimeout(() => { this.addLabel.textContent = original; this.addBtn.disabled = false; }, 1500);
        } catch (err) {
          console.error(err);
          this.addLabel.textContent = original;
          this.addBtn.disabled = false;
        }
      });
    }

  }

  if (!customElements.get('product-template')) {
    customElements.define('product-template', ProductTemplate);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-row"] && !Shopify.designMode) return;
  try {
    
  class ProductRow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-scroll-track]');
      this.prev = this.querySelector('[data-scroll-prev]');
      this.next = this.querySelector('[data-scroll-next]');
      if (!this.track || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this.scrollBy(-1));
      this.next.addEventListener('click', () => this.scrollBy(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows(), { passive: true });
      this.updateArrows();
    }

    scrollBy(direction) {
      const item = this.track.querySelector('.product-row__item');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 16;
      const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    updateArrows() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const atStart = scrollLeft <= 2;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 2;
      this.prev.toggleAttribute('disabled', atStart);
      this.next.toggleAttribute('disabled', atEnd);
    }
  }

  if (!customElements.get('product-row')) {
    customElements.define('product-row', ProductRow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-page"] && !Shopify.designMode) return;
  try {
    
  class LiteYt extends HTMLElement {
    connectedCallback() {
      this.vid = this.dataset.vid;
      this.playBtn = this.querySelector('.videos__play');
      if (this.playBtn) this.playBtn.addEventListener('click', () => this.loadIframe());
      this.addEventListener('click', () => this.loadIframe());
    }
    loadIframe() {
      if (this.querySelector('iframe')) return;
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + this.vid + '?autoplay=1&rel=0';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;';
      this.innerHTML = '';
      this.appendChild(iframe);
    }
  }
  if (!customElements.get('lite-yt')) customElements.define('lite-yt', LiteYt);

  } catch(e) { console.error(e); }
})();
})();
